import Vue from 'vue'
import App from './App.vue'
import Easing from '@/glxp/utils/easing'

Vue.config.productionTip = false


new Vue({
  render: h => h(App),
}).$mount('#app')
